// extracted by mini-css-extract-plugin
export var icon = "_ab-3";
export var subtitle = "_ab-2";
export var title = "_ab-1";
export var value = "_ab-0";